/**
 * Public music playlists for the shop music player.
 */
class MusicPlaylistService {
  constructor(apiBaseUrl, businessId) {
    this.apiBaseUrl = (apiBaseUrl || '').replace(/\/+$/, '');
    this.businessId = businessId;
  }

  async fetchPublicPlaylists() {
    if (!this.businessId) return [];
    const url = `${this.apiBaseUrl}/music-playlists/public?businessId=${encodeURIComponent(this.businessId)}`;
    const res = await fetch(url);
    if (!res.ok) return [];
    const data = await res.json();
    return Array.isArray(data.playlists) ? data.playlists : [];
  }
}

export default MusicPlaylistService;
